
export default {
    name: 'news',
    props: ['source'],
    data() {
        return {

        }
    },
    watch: {
        source(val) {
            this.source = val
        }
    },
    methods: {

    }
}
